import axiosInstance from './api';
import { FileDto } from './file.protocols';

type mailBodyProps = {
  candidateName: string;
  candidateEmail: string;
  analystRequestId: string;
  companyName: string;
};

export type messageBodyProps = {
  candidateName: string;
  candidateWhatsapp: string;
  analystRequestId: string;
  companyName: string;
};

export type whatsappMessageForced = {
  analystName: string;
  companyName: string;
  candidateName: string;
  candidateWhatsapp: string;
  candidateEmail: string;
  dateLinkSent: string | null;
  analystRequestId: string;
};

export type WhatsappStatusResponse = {
  messageSid: string | null;
  messageStatus: string | null;
  errorMessage: string | null;
  updatedAt: string | null;
};

class MessagingApi {
  static async sendMessage(
    body: messageBodyProps,
  ): Promise<{ status: string; messageSid: string } | undefined> {
    return await axiosInstance
      .post(`/messaging/send-assessment-link`, body)
      .then((response) => response.data);
  }

  static async sendWhatsAppMessageForced(
    body: whatsappMessageForced,
    typeMessage: string,
  ): Promise<{ status: string; messageSid: string } | undefined> {
    return await axiosInstance
      .post(
        `/messaging/send-whatsapp-message-forced?typeMessage=${typeMessage}`,
        body,
      )
      .then((response) => response.data);
  }

  static async getWhatsappStatus(
    analystRequestId: string,
    messageType: string,
  ): Promise<WhatsappStatusResponse> {
    return await axiosInstance
      .get(
        `/messaging/whatsapp-status/${analystRequestId}?messageType=${messageType}`,
      )
      .then((response) => response.data);
  }

  static async getWhatsappStatusBatch(
    analystRequestIds: string[],
  ): Promise<Record<string, WhatsappStatusResponse>> {
    return await axiosInstance
      .post(`/messaging/whatsapp-status/batch`, { analystRequestIds })
      .then((response) => response.data);
  }

  static async sendMail(body: mailBodyProps): Promise<FileDto> {
    const response: FileDto = await axiosInstance
      .post(`/mail/send-assessment-link`, body)
      .then((response) => response.data);
    return response;
  }
}

export { MessagingApi };
